<div class="custom-scroll-parent flex-grow-1 gpb-40">
  <div class="navigation custom-scroll lightblue-scrollbar-track gpy-16">
    <app-results-menu
      [mobile]="false"
      [collapsed]="collapsed && !isHovered"
      (navItemClicked)="onNavItemClicked()"
    />
  </div>
</div>
<div
  class="collapse-container gp-16"
  [class.d-none]="!isCollapsable"
  [gptDataTrack]="
    collapsed ? 'sidebar-collapse-toggle-off' : 'sidebar-collapse-toggle-on'
  "
  (click)="toggleCollapsed()"
>
  <div class="gp-8 d-flex flex-row align-content-center">
    <i
      [class.gpicon-arrows-left]="!collapsed"
      [class.gpicon-arrows-right]="collapsed"
    ></i>
    <span class="rt2-regular text-ellipsis gpl-12" [class.d-none]="collapsed">
      {{ 'RESULTS.MENU.COLLAPSE' | translate }}
    </span>
  </div>
</div>
